import styled from "styled-components";

export const InitialsWrapper = styled.div`
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background-color: ${window?.settings?.secondary_color ?? '#04333b'};
  color: #FFFFFF;
  font-weight: 600;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
`;